<template>
<v-form ref="form" v-model="valid">
  <v-container fluid>
    <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
    </v-app-bar>
  </nav>
  
    <v-card-title>General</v-card-title>
    <v-card>
      <v-row>
        <v-col cols="2">
          <v-subheader>Water Flow Console S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="console"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="waterFlowSn"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Water Flow Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="waterFlowConsole"> </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
        <v-subheader>Location Name</v-subheader>
        </v-col>
      <v-col cols="2">
           <v-select  
            :items="locationItem"
            item-value="_id"
            :item-text="
            (locationItem) => {
            return (locationItem.location);
            }"
            v-model="location"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>Console Power Source</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="boardName"> </v-text-field>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Total of Sensor</v-subheader>
        </v-col>
        <v-col cols="4">
           <v-radio-group
      v-model="totalSensor"
      row
    >
      <v-radio
        label="1"
        value= 1
      ></v-radio>
      <v-radio
        label="2"
        value= 2
      ></v-radio>
      <v-radio
        label="3"
        value= 3
      ></v-radio>
      <v-radio
        label="4"
        value= 4
      ></v-radio>
      <v-radio
        label="5"
        value= 5
      ></v-radio>
      <v-radio
        label="6"
        value= 6
      ></v-radio>
    </v-radio-group>
        </v-col>
      </v-row>
   </v-card>

    <v-card-title v-if="totalSensor == 1 || totalSensor == 2 || totalSensor == 3 || totalSensor == 4 || totalSensor == 5 || totalSensor == 6">Sensor Unit 1</v-card-title>
    <v-card v-if="totalSensor == 1 || totalSensor == 2 || totalSensor == 3 || totalSensor == 4 || totalSensor == 5 || totalSensor == 6">
      <v-row>
        <v-col cols="2">
          <v-subheader>Pipe Water Flow S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="waterFlowSn1"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Pipe Water Flow Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="waterFlowConsole1"> </v-text-field>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Location Remarks</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="locationItem"
            item-value="location"
            :item-text="
            (locationItem) => {
            return (locationItem.location);
            }"
            v-model="locationRemarks1"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
           <v-subheader>Outlet Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in item1" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="outletTypeItems"
          label="Select Load Type"
          v-model="type.item"
        ></v-select>
      </v-col>
            
  <v-col cols="2">
            <v-icon
            @click="deleteOutletType1(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewOutletType1">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>
   </v-card>

   <v-card-title v-if="totalSensor == 2 || totalSensor == 3 || totalSensor == 4 || totalSensor == 5 || totalSensor == 6">Sensor Unit 2</v-card-title>
    <v-card v-if="totalSensor == 2 || totalSensor == 3 || totalSensor == 4 || totalSensor == 5 || totalSensor == 6">
      <v-row>
        <v-col cols="2">
          <v-subheader>Pipe Water Flow S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="waterFlowSn2"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Pipe Water Flow Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="waterFlowConsole2"> </v-text-field>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Location Remarks</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="locationItem"
            item-value="location"
            :item-text="
            (locationItem) => {
            return (locationItem.location);
            }"
            v-model="locationRemarks2"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
           <v-subheader>Outlet Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in item2" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="outletTypeItems"
          label="Select Load Type"
          v-model="type.item"
        ></v-select>
      </v-col>
            
  <v-col cols="2">
            <v-icon
            @click="deleteOutletType2(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewOutletType2">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>
   </v-card>

    <v-card-title v-if="totalSensor == 3 || totalSensor == 4 || totalSensor == 5 || totalSensor == 6">Sensor Unit 3</v-card-title>
    <v-card v-if="totalSensor == 3 || totalSensor == 4 || totalSensor == 5 || totalSensor == 6">
      <v-row>
        <v-col cols="2">
          <v-subheader>Pipe Water Flow S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="waterFlowSn3"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Pipe Water Flow Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="waterFlowConsole3"> </v-text-field>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Location Remarks</v-subheader>
        </v-col>
       <v-col cols="2">
           <v-select  
            :items="locationItem"
            item-value="location"
            :item-text="
            (locationItem) => {
            return (locationItem.location);
            }"
            v-model="locationRemarks3"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
           <v-subheader>Outlet Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in item3" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="outletTypeItems"
          label="Select Load Type"
          v-model="type.item"
        ></v-select>
      </v-col>
            
  <v-col cols="2">
            <v-icon
            @click="deleteOutletType3(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewOutletType3">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>
   </v-card>

   <v-card-title v-if="totalSensor == 4 || totalSensor == 5 || totalSensor == 6">Sensor Unit 4</v-card-title>
    <v-card v-if="totalSensor == 4 || totalSensor == 5 || totalSensor == 6">
      <v-row>
        <v-col cols="2">
          <v-subheader>Pipe Water Flow S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="waterFlowSn4"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Pipe Water Flow Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="waterFlowConsole4"> </v-text-field>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Location Remarks</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="locationItem"
            item-value="location"
            :item-text="
            (locationItem) => {
            return (locationItem.location);
            }"
            v-model="locationRemarks4"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
           <v-subheader>Outlet Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in item4" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="outletTypeItems"
          label="Select Load Type"
          v-model="type.item"
        ></v-select>
      </v-col>
            
  <v-col cols="2">
            <v-icon
            @click="deleteOutletType4(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewOutletType4">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>
   </v-card>

   <v-card-title v-if="totalSensor == 5 || totalSensor == 6">Sensor Unit 5</v-card-title>
    <v-card v-if="totalSensor == 5 || totalSensor == 6">
      <v-row>
        <v-col cols="2">
          <v-subheader>Pipe Water Flow S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="waterFlowSn5"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Pipe Water Flow Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="waterFlowConsole5"> </v-text-field>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Location Remarks</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="locationItem"
            item-value="location"
            :item-text="
            (locationItem) => {
            return (locationItem.location);
            }"
            v-model="locationRemarks5"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
           <v-subheader>Outlet Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in item5" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="outletTypeItems"
          label="Select Load Type"
          v-model="type.item"
        ></v-select>
      </v-col>
            
  <v-col cols="2">
            <v-icon
            @click="deleteOutletType5(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewOutletType5">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>
   </v-card>

   <v-card-title v-if="totalSensor == 6">Sensor Unit 6</v-card-title>
    <v-card v-if="totalSensor == 6">
      <v-row>
        <v-col cols="2">
          <v-subheader>Pipe Water Flow S/N</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="sensor"
            item-value="serialNumber"
            :item-text="
            (serialNumber) => {
            return (serialNumber.serialNumber);
            }"
            v-model="waterFlowSn6"
            label="Serial Number*"
            >
            </v-select>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Pipe Water Flow Console Label</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-text-field v-model="waterFlowConsole6"> </v-text-field>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="2">
          <v-subheader>Location Remarks</v-subheader>
        </v-col>
        <v-col cols="2">
           <v-select  
            :items="locationItem"
            item-value="location"
            :item-text="
            (locationItem) => {
            return (locationItem.location);
            }"
            v-model="locationRemarks6"
            label="Location*"
            >
            </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
           <v-subheader>Outlet Type</v-subheader>
           </v-col>
           <v-col cols="10">
          <div v-for="(type, idx) in item6" :key="idx">
            <v-row>
              <v-col cols="2">
        <v-select
          :items="outletTypeItems"
          label="Select Load Type"
          v-model="type.item"
        ></v-select>
      </v-col>
            
  <v-col cols="2">
            <v-icon
            @click="deleteOutletType6(idx)"
      medium
      color="red darken-2"
    >
      mdi-delete
    </v-icon>
  </v-col>
            </v-row>
        </div>
          <v-btn fab dark small color="accent" @click="addNewOutletType6">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
           </v-col>
      </v-row>
   </v-card>

     <v-btn fixed dark fab bottom right color="blue" @click="saveItem()">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
  </v-container>
</v-form>
</template>


<script>
import axios from "axios";
import router from "../../router";

export default {
  data() {
    return {
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Settings',
          disabled: true,
          href: '',
        },
        {
          text: 'Water Flow',
          disabled: false,
          href: '/water-board',
        },
        {
          text: 'Add',
          disabled: true,
          href: '',
        }
      ],
    outletTypeItems: ["Basin", "Bidet", "Shower", "Water Tap"],
    waterFlowSn: "",
    waterFlowConsole: "",
    boardName: "",
    location: "",
    totalSensor: null,
    waterFlowSn1: "",
    waterFlowConsole1: "",
    locationRemarks1: "",
    item1:[],
    waterFlowSn2: "",
    waterFlowConsole2: "",
    locationRemarks2: "",
    item2: [],
    waterFlowSn3: "",
    waterFlowConsole3: "",
    locationRemarks3: "",
    item3: [],
    waterFlowSn4: "",
    waterFlowConsole4: "",
    locationRemarks4: "",
    item4: [],
    waterFlowSn5: "",
    waterFlowConsole5: "",
    locationRemarks5: "",
    item5: [],
    waterFlowSn6: "",
    waterFlowConsole6: "",
    locationRemarks6: "",
    item6: [],
    modifiedBy: "",

    valid: true,
    console: [],
    sensor: [],
    locationItem: [], 
    showDeleteDialog: false,
    };
  },
  created(){
      this.loadsConsole();
      this.loadsSensor();
      this.loadsLocation();
  },
  methods: {
    addNewOutletType1() {
      this.item1.push({item: this.item});
    },
    deleteOutletType1(idx) {
      this.item1.splice(idx, 1);
    },
   addNewOutletType2() {
      this.item2.push({item: this.item});
    },
    deleteOutletType2(idx) {
      this.item2.splice(idx, 1);
    },
    addNewOutletType3() {
      this.item3.push({item: this.item});
    },
    deleteOutletType3(idx) {
      this.item3.splice(idx, 1);
    },
   addNewOutletType4() {
      this.item4.push({item: this.item});
    },
    deleteOutletType4(idx) {
      this.item4.splice(idx, 1);
    },
    addNewOutletType5() {
      this.item5.push({item: this.item});
    },
    deleteOutletType5(idx) {
      this.item5.splice(idx, 1);
    },
   addNewOutletType6() {
      this.item6.push({item: this.item});
    },
    deleteOutletType6(idx) {
      this.item6.splice(idx, 1);
    },
    loadsLocation: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/location";
    axios.get(apiURL).then(res => {
    this.locationItem = res.data;
    }).catch(error => {
        console.log(error)
    });
  },
    loadsConsole: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/serial-number-flow-con";
    axios.get(apiURL).then(res => {
    this.console = res.data;
    }).catch(error => {
        console.log(error)
    });
  },
    loadsSensor: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/serial-number-flow-sen";
    axios.get(apiURL).then(res => {
    this.sensor = res.data;
    }).catch(error => {
        console.log(error)
    });
  },
    async saveItem() {
      if (this.$refs.form.validate()) {
      let apiURL = process.env.VUE_APP_API + "/api/create-water-board";
      axios
        .post(
      apiURL,
          {
    waterFlowSn: this.waterFlowSn,
    waterFlowConsole: this.waterFlowConsole,
    boardName: this.boardName,
    location: this.location,
    totalSensor: this.totalSensor,
    waterFlowSn1: this.waterFlowSn1,
    waterFlowConsole1: this.waterFlowConsole1,
    locationRemarks1: this.locationRemarks1,
    item1: this.item1,
    waterFlowSn2: this.waterFlowSn2,
    waterFlowConsole2: this.waterFlowConsole2,
    locationRemarks2: this.locationRemarks2,
    item2: this.item2,
    waterFlowSn3: this.waterFlowSn3,
    waterFlowConsole3: this.waterFlowConsole3,
    locationRemarks3: this.locationRemarks3,
    item3: this.item3,
    waterFlowSn4: this.waterFlowSn4,
    waterFlowConsole4: this.waterFlowConsole4,
    locationRemarks4: this.locationRemarks4,
    item4: this.item4,
    waterFlowSn5: this.waterFlowSn5,
    waterFlowConsole5: this.waterFlowConsole5,
    locationRemarks5: this.locationRemarks5,
    item5: this.item5,
    waterFlowSn6: this.waterFlowSn6,
    waterFlowConsole6: this.waterFlowConsole6,
    locationRemarks6: this.locationRemarks6,
    item6: this.item6,

    modifiedBy: this.$keycloak.tokenParsed.given_name
          });
    }
     router.go(-1);
      }
    }
  };
</script>